import React from "react";
import { Routes, Route } from "react-router-dom";
import List from "./List";
import Details from "./Details";
import { Header } from "semantic-ui-react";

function PdfReports() {
  return (
    <>
      <Header as="h2" style={{ marginTop: "20px" }}>
      Presentation Reports
        <Header.Subheader>List of Presentation reports</Header.Subheader>
      </Header>
      <Routes>
        <Route path="/" element={<List />} />
        <Route path="details/:id" element={<Details />} />
      </Routes>
    </>
  );
}

export default PdfReports;
